import ProductEdit from './Container'
export default ProductEdit


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/index.js